import { Box, Flex, Stack, type ResponsiveValue } from "@chakra-ui/react";
import { CookieBanner } from "./cookiesConsent/cookieBanner";
import { Footer } from "./Footer";
import { Header } from "./Header";

interface LayoutProps {
  maxWidth?: ResponsiveValue<string | number>;
  children: React.ReactNode;
}

export const Layout: React.FC<LayoutProps> = ({
  maxWidth = "1080px",
  children,
}) => {
  // TODO: use router fallbackLocale
  return (
    <>
      <CookieBanner />
      <Stack
        backgroundColor="monochrome.super-light-gray"
        backgroundImage="url('/cross_background.svg')"
        backgroundRepeat="repeat"
        backgroundAttachment="scroll"
      >
        <Box position="fixed" width="full" zIndex={10}>
          <Header />
        </Box>
        <Flex as="main" direction="column" align="center">
          <Box
            marginTop={{ base: "68px", xl: "78px" }}
            paddingX={{ base: "21px", xl: "68px" }}
            paddingY={{ base: "21px", xl: "34px" }}
            maxWidth={maxWidth}
            width="full"
          >
            {children}
          </Box>
        </Flex>
        <Footer />
      </Stack>
    </>
  );
};
